export default __webpack_public_path__ + "static/img/wood.0a2366c.png";